import { setClassName } from '@change-corgi/core/error';

import { PageDataError } from '#src/shared/error';

export type PetitionAngleData = {
	readonly id: string;
	readonly recommendation: string;
	readonly why: string;
	readonly ask: string;
	readonly description: string;
};

export type PetitionAnglesPageData = {
	readonly token: string;
	readonly username: string | null;
	readonly name: string | null;
	readonly platform: string | null;
	readonly avatarUrl: string | null;
	readonly videoCoverUrl: string | null;
	readonly caption: string | null;
	readonly drafts: readonly PetitionAngleData[];
	readonly sourceLocation: string | null;
	readonly videoConsentCheckboxEnabled: boolean;
};

export type PetitionAnglesPageDataErrorCode = 'social_starter_not_found';
export class PetitionAnglesPageDataError extends PageDataError<PetitionAnglesPageDataErrorCode> {}
setClassName(PetitionAnglesPageDataError, 'PetitionAnglesPageDataError');
